import http from "../api/http";
import { api } from "../api/environment";
import {
  ServerResponse,
  IReceipt,
  IReceiptDetail,
  INewReceipt,
  IUpdateReceipt,
  IDeleteReceiptDetail,
  IReceiptName,
} from "../types/global";

const getAll = (
  maxResultCount: number,
  skipCount?: number,
  search?: string,
  status?: boolean,
  expiredFilter?: number
) => {
  return http.get<ServerResponse<IReceipt>>(
    `/services/app${api.RECEIPT_SERVICE}/GetAll?${
      maxResultCount ? "MaxResultCount=" + maxResultCount + "&" : ""
    }${skipCount ? "SkipCount=" + skipCount + "&" : ""}${
      search ? "Search=" + search + "&" : ""
    }${status === undefined ? "" : "Status=" + status + "&"}${
      expiredFilter === 0 ? "" : "statusFilter=" + expiredFilter + "&"
    }`
  );
};

const get = (id: number) => {
  return http.get<IReceiptDetail>(
    `/services/app${api.RECEIPT_SERVICE}/Get?Id=${id}`
  );
};

const create = (payload: INewReceipt) => {
  return http.post(`/services/app${api.RECEIPT_SERVICE}/Create`, payload);
};

const remove = (id: number, employeeCode: string) => {
  return http.delete(
    `/services/app${api.RECEIPT_SERVICE}/Delete?Id=${id}&employeeCode=${employeeCode}`
  );
};

const close = (id: number, employeeCode: string, applicant?: string) => {
  return http.put(
    `/services/app${
      api.RECEIPT_SERVICE
    }/UpdateReceiptStatus?receiptId=${id}&employeeCode=${employeeCode}&applicant=${
      applicant || ""
    }`
  );
};

const put = (payload: IUpdateReceipt | IDeleteReceiptDetail) => {
  return http.put(`/services/app${api.RECEIPT_SERVICE}/Update`, payload);
};

const putName = (payload: IReceiptName) => {
  return http.put(
    `/services/app${api.RECEIPT_SERVICE}/UpdateReceiptName`,
    payload
  );
};

export const receiptService = {
  getAll,
  get,
  create,
  remove,
  close,
  put,
  putName,
};
